import React, { useCallback } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';

// Memoized component for individual table rows to optimize performance
const FailureTableRow = React.memo(
  ({ failure, getStatusColor, onViewFullDetails }) => {
    const handleViewFullDetails = useCallback(() => {
      onViewFullDetails(failure.id);
    }, [failure.id, onViewFullDetails]);

    return (
      <TableRow
        hover
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>{failure.timestamp.toLocaleString()}</TableCell>
        <TableCell>{failure.breweryName}</TableCell>
        <TableCell>{failure.errorType}</TableCell>
        <TableCell>{failure.errorLocation}</TableCell>
        <TableCell>
          <Chip
            label={failure.status}
            color={getStatusColor(failure.status)}
            size="small"
          />
        </TableCell>
        <TableCell>
          <Tooltip title="View Full Details">
            <IconButton size="small" onClick={handleViewFullDetails}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  },
);

FailureTableRow.displayName = 'FailureTableRow';

export default FailureTableRow;
